<div *ngIf="isRequestInFlight()" class="text-center">
  <i id="case-view-spinner" class="fa fa-spinner fa-spin fa-5x text-center"></i>
</div>

<alert type="danger" *ngFor="let error of errors">{{error}}</alert>

<div *ngIf="selectedCase">
  <div *ngIf="selectedCase.getCaseIdentifier().type === 'CIVIL'">    
    <app-civil-case-view [civilCase]="selectedCase"></app-civil-case-view>
  </div>
  <div *ngIf="selectedCase.getCaseIdentifier().type === 'JUVENILE'">    
    <app-juvenile-case-view [juvenileCase]="selectedCase"></app-juvenile-case-view>
  </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/case-view.component.html